import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { SmartEditRootModule } from '@spartacus/smartedit/root';

@NgModule({
  declarations: [],
  imports: [
    SmartEditRootModule
  ],
  // tslint:disable-next-line:no-angle-bracket-type-assertion
  providers: [provideConfig(<CmsConfig> {
    featureModules: {
      smartEdit: {
        module: () =>
          import('@spartacus/smartedit').then((m) => m.SmartEditModule),
      },
    }
  })]
})
export class SmartEditFeatureModule { }
